<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Swal from '@/utils/ugm-swal';
import Stat from "../../components/widgets/stat";
import Multiselect from 'vue-multiselect';
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader, Stat, Multiselect },
    data() {
        return {
            title: "Laborantes",
            items: [
                {
                text: "Laborantes",
                href: "/web/configuracion/laborantes"
                },
            ],
            usuarios:[],
            // filtros
            selectedNombre: null,    // filtro por nombre (objeto { id, name })
            nombrePlaceholder: 'Seleccionar nombre',
            datos_editar:{
                tipo:'',
                rut:'',
                nombre:'',
                correo:'',
                telefono:'',
                carrera:'',
                ano:'',
                retencion:{},
                banco:{},
                tipo_cuenta:{},
                n_cuenta:''
            },
            habilitar_boton: false,  
            editing: false,
            editingId: null,
            originalUser:'',
            emailError:'',
            phoneerror:'',
            bancos:[],
            tipo:['Cuenta Vista', 'Cuenta Rut', 'Cuenta Corriente', 'Cuenta Ahorro'],
            retencion:['15,25', '25'],
        };
    },
    computed: {
        // nombres filtrados (todos los usuarios disponibles)
        nombresOptions() {
            let list = this.usuarios;
            const mapped = list.map(u => ({ id: u.id, name: u.name || u.nombre || '' }));
            const uniq = [];
            const seen = new Set();
            for (const it of mapped) {
                if (!seen.has(it.id)) {
                    seen.add(it.id);
                    uniq.push(it);
                }
            }
            return uniq.sort((a,b) => a.name.localeCompare(b.name));
        },
        // usuarios filtrados por nombre si está seleccionado
        filteredUsuarios() {
            let result = this.usuarios.slice();
            if (this.selectedNombre && this.selectedNombre.id) {
                result = result.filter(u => u.id === this.selectedNombre.id);
            }
            return result;
        },
        // mantiene compatibilidad con isEmailValid existente
        isEmailValid() {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailPattern.test(this.datos_editar.email);
        }
    },
    mounted() {
    },
    methods: {
        msg(tipo,titulo){
            Swal.fire({
                //position: "top-end",
                icon: tipo,
                title: titulo,
                //text: '',
                showConfirmButton: false,
                timer: 5000
            });
        },
        toggleEdit(usuario) {
            this.originalUser = { ...usuario };
            if (this.editing && this.editingId === usuario.id) {
                this.isLoading=true
                axios.post('/api/editar_usuario_laborantes',this.datos_editar).then(res=>{
                    if(res.data.estado){
                        this.usuarios=res.data.usuarios;
                        this.msg(res.data.color,res.data.mensaje);
                        //window.location.reload(); 
                    }else{
                        this.msg(res.data.color,res.data.mensaje);
                    }
                    this.isLoading=false
                })
            }else{
                this.editingId = usuario.id;
                this.datos_editar.id=usuario.id;
                this.datos_editar.name=usuario.name;
                this.datos_editar.rut=usuario.rut;
                this.datos_editar.email=usuario.email;
                this.datos_editar.cargo=usuario.cargo;
                this.datos_editar.telefono=usuario.telefono;
                this.datos_editar.carrera=usuario.carrera;
                this.datos_editar.ano=usuario.ano;
                this.datos_editar.retencion=usuario.retencion;
                this.datos_editar.banco= this.bancos.filter((ban) => ban.id==usuario.banco)[0];
                this.datos_editar.tipo_cuenta=usuario.tipo_cuenta;
                this.datos_editar.n_cuenta=usuario.n_cuenta;
            }
            this.editing = !this.editing;
            if (!this.editing) this.editingId = null;
        },
        cancelEdit() {
            this.editing = false;
            this.editingId = null;
        },
        ver_mas(usuario){
            this.editing = false;
            if (usuario.boton=='Ver más') {
                usuario.boton='Ver menos'
            }else if(usuario.boton=='Ver menos'){
                usuario.boton='Ver más'
            }
        },
        labelselect_tipo ({ nombre }) {
            return `${nombre}`
        },
        formatRut() {
            // Eliminamos todos los caracteres que no sean números o 'k'
            let cleanRut = this.datos_editar.rut.replace(/[^0-9kK]/g, "").toUpperCase();
            if (cleanRut.length > 10) {
                cleanRut = cleanRut.slice(0, 10); // Limitar a 9 dígitos + DV
            }
            // Si el RUT tiene más de un carácter, separamos el dígito verificador
            if (cleanRut.length > 1) {
                const body = cleanRut.slice(0, -1); // Todo menos el último carácter
                const dv = cleanRut.slice(-1); // Último carácter como dígito verificador
                // Agregamos los puntos cada tres dígitos al cuerpo
                const formattedBody = body.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                // Concatenamos el cuerpo formateado con el dígito verificador
                this.datos_editar.rut = `${formattedBody}-${dv}`;
            } else {
                // Si el RUT tiene un solo carácter, lo dejamos tal cual
                this.datos_editar.rut = cleanRut;
            }

            this.cuentaRut();
        },
        cleanRut(value) {
            return String(value || '').replace(/^0+|[^0-9kK]+/g, '').toUpperCase();
        },
        getRutBodyWithoutDv(value) {
            const cleanRut = this.cleanRut(value);
            return cleanRut.length > 1 ? cleanRut.slice(0, -1) : '';
        },
        cuentaRut() {
            if (this.datos_editar.tipo_cuenta === 'Cuenta Rut') {
                this.datos_editar.n_cuenta = this.getRutBodyWithoutDv(this.datos_editar.rut);
            } else {
                this.datos_editar.n_cuenta = '';
            }
        },
        validateEmail() {
            if (this.datos_editar.email && !this.isEmailValid) {
                this.emailError = 'El correo electrónico no es válido.';
            } else {
                this.emailError = '';
            }
        },
        formatPhoneNumber() {
            // Elimina todo lo que no sea número
            let digits = this.datos_editar.telefono.replace(/\D/g, "");
            // Agrega el prefijo "+56" si no está presente
            if (!digits.startsWith("56")) {
                digits = "56" + digits;
            }
            // Limita a un máximo de 11 caracteres (+56 + 9 dígitos)
            if (digits.length > 11) {
                digits = digits.slice(0, 11);
            }
            // Actualiza el input con el formato correcto
            this.datos_editar.telefono = "+" + digits;
        },
        validatePhoneNumber() {
            // Validar que el número tenga exactamente 11 caracteres (+56 + 9 dígitos)
            if (this.datos_editar.telefono.length !== 12) {
                this.phoneerror = "El número debe ser +56 seguido de 9 dígitos.";
            } else {
                this.phoneerror = "";
                //alert("Número válido: " + this.datos.telefono);
                // Aquí puedes continuar con el envío del formulario
            }
        },
        restrictToNumbers(event) {
            const allowedKeys = [
                "Backspace",
                "Tab",
                "ArrowLeft",
                "ArrowRight",
                "Delete",
            ];
            // Permitir teclas especiales y números
            if (
                !allowedKeys.includes(event.key) &&
                !/^\d$/.test(event.key) // Permitir solo números
            ) {
                event.preventDefault();
            }
        },
        restrictInput(event) {
            // Permitir solo letras y teclas de control (Backspace, Delete, etc.)
            const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
            const isLetter = /^[a-zA-Z]$/.test(event.key);
            if (!isLetter && !allowedKeys.includes(event.key)) {
                event.preventDefault(); // Previene la entrada de caracteres no permitidos
            }
        },
        restrictInput_withspace(event) {
            // Permitir solo letras, espacios y teclas de control (Backspace, Delete, etc.)
            const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
            const isLetterOrSpace = /^[a-zA-Z\s]$/.test(event.key);

            if (!isLetterOrSpace && !allowedKeys.includes(event.key)) {
                event.preventDefault(); // Previene la entrada de caracteres no permitidos
            }
        },
        obtenerBanco(element){
            let banco = this.bancos.filter((ban) => ban.id==element);
            if (banco.length>0) {
                return banco[0].nombre;
            }
        },
        eliminar(usuario){
            let formData = new FormData();
            formData.append('usuario_id', usuario.id);
            axios.post('/api/eliminar_laborante',formData).then(res=>{
                if(res.data.estado){
                    this.usuarios=res.data.usuarios;
                    this.msg(res.data.color,res.data.mensaje);
                }else{
                    this.msg(res.data.color,res.data.mensaje);
                }
            })
        },
        async actualizarRetencionMasiva(){
            const result = await Swal.fire({
                title: 'Actualizar retención laborantes',
                text: 'Ingresa el porcentaje a aplicar',
                input: 'text',
                inputValue: '15,25',
                inputPlaceholder: 'Ej: 15,25',
                showCancelButton: true,
                confirmButtonText: 'Actualizar',
                cancelButtonText: 'Cancelar',
                inputValidator: (value) => {
                    if (!value || !String(value).trim()) {
                        return 'Debes ingresar un porcentaje';
                    }
                    const limpio = String(value).trim();
                    if (!/^\d{1,2}(,\d{1,2})?$/.test(limpio)) {
                        return 'Formato inválido. Usa formato como 15,25';
                    }
                    return null;
                }
            });

            if (!result.isConfirmed) return;

            axios.post('/api/actualizar_retencion_laborantes', {
                retencion: String(result.value).trim()
            }).then(res => {
                if (res.data && res.data.estado) {
                    this.usuarios = res.data.usuarios || this.usuarios;
                    this.msg(res.data.color || 'success', res.data.mensaje || 'Retención actualizada');
                } else {
                    this.msg((res.data && res.data.color) || 'error', (res.data && res.data.mensaje) || 'No se pudo actualizar');
                }
            }).catch(() => {
                this.msg('error', 'No se pudo actualizar la retención');
            });
        }
    },
    created(){
        axios.get('/api/get_laborantes').then(res=>{
            this.usuarios=res.data.usuarios;
        });
        axios.get('/api/get_bancos').then(response => {
            this.bancos = response.data.bancos;
        });
    },
    watch: {
        // limpiar nombre seleccionado si ya no existe en la lista
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header py-3 d-flex align-items-center"
                        style="background: linear-gradient(135deg, #252C5F 0%, #61B7E4 100%); border-radius: 4px 4px 0 0;">
                        <i class="bx bx-id-card font-size-24 text-white mr-2"></i>
                        <div>
                            <h5 class="text-white mb-0 font-weight-bold">Laborantes</h5>
                            <small class="text-white" style="opacity:.8;">Administra los laborantes de la plataforma</small>
                        </div>
                    </div>
                    <div class="card-body pt-3 pb-2">

                        <!-- Filtros y acciones -->
                        <div class="row align-items-end mb-2">
                            <div class="col-md-5">
                                <label class="small font-weight-bold mb-1" style="color:#252C5F;">Filtrar por nombre</label>
                                <multiselect
                                    v-model="selectedNombre"
                                    :options="nombresOptions"
                                    :searchable="true"
                                    :clear-on-select="true"
                                    :close-on-select="true"
                                    placeholder="Seleccionar nombre"
                                    label="name"
                                    track-by="id"
                                />
                            </div>
                            <div class="col-md-7 d-flex justify-content-end align-items-end">
                                <button type="button" class="btn btn-sm" @click="actualizarRetencionMasiva"
                                    style="background:#CB9700;border-color:#CB9700;color:#fff;">
                                    <i class="bx bx-refresh mr-1"></i> Actualizar retención masiva
                                </button>
                            </div>
                        </div>

                        <!-- Tabla -->
                        <div class="table-responsive">
                            <table class="table table-hover mb-0">
                                <thead>
                                    <tr style="border-bottom:2px solid #252C5F;">
                                        <th style="color:#252C5F;width:40px;">#</th>
                                        <th style="color:#252C5F;">Nombre</th>
                                        <th style="color:#252C5F;width:150px;">RUT</th>
                                        <th style="color:#252C5F;width:120px;">Retención</th>
                                        <th style="color:#252C5F;text-align:right;width:120px;">Detalle</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="(usuario, index) in filteredUsuarios">
                                        <tr :key="'row-' + usuario.id">
                                            <td class="align-middle text-muted small">{{ index + 1 }}</td>
                                            <td class="align-middle font-weight-bold" style="color:#252C5F;">{{ usuario.name }}</td>
                                            <td class="align-middle text-muted small">{{ usuario.rut }}</td>
                                            <td class="align-middle">
                                                <span class="badge"
                                                    style="background:#f0f3ff;color:#252C5F;font-size:0.82em;padding:4px 8px;border-radius:12px;">
                                                    {{ usuario.retencion }}%
                                                </span>
                                            </td>
                                            <td class="align-middle text-right">
                                                <b-button size="sm" variant="outline-secondary"
                                                    v-b-toggle="'lab-' + usuario.id"
                                                    @click="ver_mas(usuario)">
                                                    <i :class="usuario.boton === 'Ver menos' ? 'bx bx-chevron-up' : 'bx bx-chevron-down'"></i>
                                                </b-button>
                                            </td>
                                        </tr>
                                        <tr :key="'detail-' + usuario.id">
                                            <td colspan="5" class="p-0 border-0">
                                                <b-collapse :id="'lab-' + usuario.id">
                                                    <div class="p-3" style="background:#f8f9fc;border-left:4px solid #252C5F;margin:0 8px 8px 8px;border-radius:0 0 6px 6px;">

                                                        <!-- Vista de detalle -->
                                                        <div v-if="!editing || editingId !== usuario.id">
                                                            <div class="row">
                                                                <div class="col-md-6">
                                                                    <p class="mb-1 small"><strong>RUT:</strong> {{ usuario.rut }}</p>
                                                                    <p class="mb-1 small"><strong>Correo:</strong> {{ usuario.email }}</p>
                                                                    <p class="mb-1 small"><strong>Teléfono:</strong> {{ usuario.telefono }}</p>
                                                                    <p class="mb-1 small"><strong>Carrera:</strong> {{ usuario.carrera }}</p>
                                                                    <p class="mb-1 small"><strong>Año:</strong> {{ usuario.ano }}</p>
                                                                    <p class="mb-1 small"><strong>Eventos asignados:</strong> {{ usuario.eventos_asignados || 0 }}</p>
                                                                </div>
                                                                <div class="col-md-6">
                                                                    <p class="mb-1 small"><strong>Retención:</strong> {{ usuario.retencion }}%</p>
                                                                    <p class="mb-1 small"><strong>Banco:</strong> {{ obtenerBanco(usuario.banco) }}</p>
                                                                    <p class="mb-1 small"><strong>Tipo cuenta:</strong> {{ usuario.tipo_cuenta }}</p>
                                                                    <p class="mb-1 small"><strong>Nº Cuenta:</strong> {{ usuario.n_cuenta }}</p>
                                                                </div>
                                                            </div>
                                                            <div class="mt-3 d-flex justify-content-end" style="gap:8px;">
                                                                <button type="button" class="btn btn-sm"
                                                                    @click="toggleEdit(usuario)"
                                                                    style="background:#252C5F;border-color:#252C5F;color:#fff;">
                                                                    <i class="bx bx-edit mr-1"></i> Editar
                                                                </button>
                                                                <b-button size="sm" variant="danger" @click="eliminar(usuario)">
                                                                    <i class="bx bx-trash"></i>
                                                                </b-button>
                                                            </div>
                                                        </div>

                                                        <!-- Formulario de edición -->
                                                        <div v-if="editing && editingId === usuario.id">
                                                            <div class="p-2 mb-3 rounded" style="border-left:3px solid #252C5F;background:#fff;">
                                                                <span class="small font-weight-bold" style="color:#252C5F;">
                                                                    <i class="bx bx-user mr-1"></i> Datos Personales
                                                                </span>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-md-6">
                                                                    <b-form-group label="RUT :">
                                                                        <b-form-input class="border-primary" v-model="datos_editar.rut"
                                                                            @input="formatRut()" maxlength="12"></b-form-input>
                                                                    </b-form-group>
                                                                    <b-form-group label="Nombre :">
                                                                        <b-form-input class="border-primary" v-model="datos_editar.name"
                                                                            @keydown="restrictInput_withspace"></b-form-input>
                                                                    </b-form-group>
                                                                    <b-form-group label="Correo :">
                                                                        <b-form-input class="border-primary" v-model="datos_editar.email"
                                                                            @blur="validateEmail"></b-form-input>
                                                                        <p v-if="emailError" class="small text-danger mt-1">{{ emailError }}</p>
                                                                    </b-form-group>
                                                                </div>
                                                                <div class="col-md-6">
                                                                    <b-form-group label="Teléfono :">
                                                                        <b-form-input class="border-primary" v-model="datos_editar.telefono"
                                                                            @input="formatPhoneNumber" @blur="validatePhoneNumber"
                                                                            @keydown="restrictToNumbers" maxlength="12"></b-form-input>
                                                                        <p v-if="phoneerror" class="small text-danger mt-1">{{ phoneerror }}</p>
                                                                    </b-form-group>
                                                                    <b-form-group label="Carrera :">
                                                                        <b-form-input class="border-primary" v-model="datos_editar.carrera"
                                                                            @keydown="restrictInput_withspace"></b-form-input>
                                                                    </b-form-group>
                                                                    <b-form-group label="Año :">
                                                                        <b-form-input class="border-primary" v-model="datos_editar.ano"
                                                                            @keydown="restrictToNumbers"></b-form-input>
                                                                    </b-form-group>
                                                                </div>
                                                            </div>

                                                            <div class="p-2 mb-3 mt-1 rounded" style="border-left:3px solid #CB9700;background:#fff;">
                                                                <span class="small font-weight-bold" style="color:#CB9700;">
                                                                    <i class="bx bx-wallet mr-1"></i> Datos Bancarios
                                                                </span>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-md-6">
                                                                    <b-form-group label="% Retención :">
                                                                        <multiselect v-model="datos_editar.retencion" :options="retencion"
                                                                            placeholder="Seleccionar" selectLabel="Presiona para seleccionar"
                                                                            selectedLabel="Seleccionado" deselectLabel="Presiona para remover">
                                                                            <template v-slot:noOptions><p>No hay opciones</p></template>
                                                                            <template v-slot:noResult><p>Sin coincidencia</p></template>
                                                                        </multiselect>
                                                                    </b-form-group>
                                                                    <b-form-group label="Banco :">
                                                                        <multiselect v-model="datos_editar.banco" :options="bancos"
                                                                            :custom-label="labelselect_tipo" placeholder="Seleccionar"
                                                                            selectLabel="Presiona para seleccionar" selectedLabel="Seleccionado"
                                                                            deselectLabel="Presiona para remover">
                                                                            <template v-slot:noOptions><p>No hay opciones</p></template>
                                                                            <template v-slot:noResult><p>Sin coincidencia</p></template>
                                                                        </multiselect>
                                                                    </b-form-group>
                                                                </div>
                                                                <div class="col-md-6">
                                                                    <b-form-group label="Tipo de Cuenta :">
                                                                        <multiselect v-model="datos_editar.tipo_cuenta" :options="tipo"
                                                                            placeholder="Seleccionar" selectLabel="Presiona para seleccionar"
                                                                            selectedLabel="Seleccionado" deselectLabel="Presiona para remover"
                                                                            @select="cuentaRut">
                                                                            <template v-slot:noOptions><p>No hay opciones</p></template>
                                                                            <template v-slot:noResult><p>Sin coincidencia</p></template>
                                                                        </multiselect>
                                                                    </b-form-group>
                                                                    <b-form-group label="Nº Cuenta :">
                                                                        <b-form-input class="border-primary" v-model="datos_editar.n_cuenta"></b-form-input>
                                                                    </b-form-group>
                                                                </div>
                                                            </div>

                                                            <div class="d-flex justify-content-end mt-2" style="gap:8px;">
                                                                <button type="button" class="btn btn-sm btn-secondary" @click="cancelEdit">
                                                                    <i class="bx bx-x mr-1"></i> Cancelar
                                                                </button>
                                                                <button type="button" class="btn btn-sm" @click="toggleEdit(usuario)"
                                                                    style="background:#252C5F;border-color:#252C5F;color:#fff;">
                                                                    <i class="bx bx-save mr-1"></i> Guardar cambios
                                                                </button>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </b-collapse>
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>